module.exports = __webpack_public_path__ + "static/media/DSC_0359.f9999fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0359.jpg
// module id = 575
// module chunks = 0